<template>
  <div class="page">
    <div class="container">
      <div class="row">
        <div class="col pt-3">
          <two-label
            :twoLines="true"
            firstLabel="I have never paddled before. Will that be a problem?"
            secondLabel="No. A lot of our customers are first-timers. Our staff will be happy to listen to your concerns and walk through the basics."
          />

          <two-label
            :twoLines="true"
            firstLabel="Am I required to wear a life jacket?"
            secondLabel="Every paddler must wear a properly fitted life jacket at all times while renting our boats - absolutely no exceptions."
          />

          <two-label
            :twoLines="true"
            firstLabel="Do you provide paddles and life jackets?"
            secondLabel="Paddles and personal life jackets are included with your rental."
          />

          <two-label
            :twoLines="true"
            firstLabel="Do you have a minimum age requirement?"
            secondLabel="Three (3) years of age and no less than 35 pounds. Please note, minimum age at Clark Park is 5 years, 45 lbs."
          />

          <two-label
            :twoLines="true"
            firstLabel="Why do you have a stricter age requirements at Clark Park?"
            secondLabel="River conditions at this location are variable and are sometimes not suitable for young children."
          />

          <two-label
            :twoLines="true"
            firstLabel="Do I need to bring ID?"
            secondLabel="Yes, we will hold on to your driver’s license or state-issued ID while you rent from us."
          />

          <two-label
            :twoLines="true"
            firstLabel="I have signed a waiver–can my children under 16 years’ of age paddle unsupervised?"
            secondLabel="Absolutely not!"
          />

          <two-label
            :twoLines="true"
            firstLabel="Am I likely to see any wildlife?"
            secondLabel="It depends which location, but customers regularly report sightings of bald eagles, herons, egrets, turtles, coyotes, beaver, and mink."
          />
          
          <two-label
            :twoLines="true"
            firstLabel="Can I bring alcohol or recreational marijuana on my boat?"
            secondLabel="Absolutely not!"
          />

          <two-label
            :twoLines="true"
            firstLabel="Do I need to make a reservation? "
            secondLabel="No. We operate on a first-come, first-served basis. While we do not accept reservations, the likelihood of us having boats available for you is always pretty good."
          />

          <!-- <two-label
            :twoLines="true"
            firstLabel="Is swimming permitted at any of your five locations?"
            secondLabel="Sorry, swimming is prohibited at all locations."
          />-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwoLabel from "../TwoLabel";
export default {
  name: "Faq",
  components: {
    TwoLabel
  },
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  background-image: url("../../assets/pic4.jpg");
  background-color: grey;
  color: white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  width: 100%;
  display: flex;
}
.col {
  background: rgba(0, 0, 0, 0.5);
}
</style>
